// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import React from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { GenderNavSection as Props } from '../../../../../../types/graphql'

import { Container, SelectedGender } from './styles'

export const GenderNavSection: React.FC<Props> = ({ alternateGenderHandle, selectedGender }) => {
  const {
    collections: {
      genderNavSection: { womens, mens },
    },
  } = useTranslation()
  const normalizedGender =
    selectedGender.slice(-1) === 's' ? selectedGender.slice(0, -1) : selectedGender

  return (
    <Container>
      {normalizedGender === 'Women' ? (
        <>
          <SelectedGender>{womens}</SelectedGender>
          <Link href={`/collections/${alternateGenderHandle}`}>{mens}</Link>
        </>
      ) : (
        <>
          <Link href={`/collections/${alternateGenderHandle}`}>{womens}</Link>
          <SelectedGender>{mens}</SelectedGender>
        </>
      )}
    </Container>
  )
}
